import axios from '@/plugins/axios'

const apiEndPoint = 'admin/sales-agent'
const apiEndPointSale = 'admin/sales-order'

export default {
    namespaced: true,

    state: {
        orderlist: [],
        startdate: new Date(new Date().setDate(new Date().getDate() - 30)).toISOString(),
        enddate: new Date().toISOString(),
        page: 0,
        option: {
            roles: 'sales-agent',
            isVerified: 'approve'
        },
        orderDetail: {}
    },

    getters: {
    },

    mutations: {
        setOrderlist (state, orderlist) {
            state.orderlist = orderlist
        },
        setOrderDetail (state, orderDetail) {
            state.orderDetail = orderDetail
        },
        setOption (state, optionData) {
            state.option = optionData
        },
        setStartdate (state, sDate) {
            state.startdate = sDate
        },
        setEnddate (state, eDate) {
            state.enddate = eDate
        },
        setPage (state, ePage) {
            state.page = ePage
        }
    },

    actions: {
        async fetchOrderlist (context) {
            const response = await axios.post(`${apiEndPoint}?startDate=${context.state.startdate}&endDate=${context.state.enddate}&page=${context.state.page}&perPage=50`, context.state.option)
            const orderlist = response
            context.commit('setOrderlist', orderlist.content)
            var calTotal = response.totalItems / 50
            this.totalPage = Math.ceil(calTotal)
            return Math.ceil(calTotal)
        },

        async patchOrderDetail (context) {
            const response = await axios.patch(`${apiEndPointSale}`, context.state.orderDetail)
            const patchUpdate = response
            console.log(context.state.agentdetail)
            console.log(patchUpdate)
        }
    }
}
